import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsToyotaComponent } from './simple-icons-toyota.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsToyotaComponent ],
    exports:      [ SimpleIconsToyotaComponent ],
    bootstrap:    []
})
export class SimpleIconsToyotaModule {}
